import { render, staticRenderFns } from "./PayrollOverviewDetails.vue?vue&type=template&id=7a925840&scoped=true&"
import script from "./PayrollOverviewDetails.vue?vue&type=script&lang=js&"
export * from "./PayrollOverviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./PayrollOverviewDetails.vue?vue&type=style&index=0&id=7a925840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a925840",
  null
  
)

export default component.exports